@let v = vm();

<div class="hd-basic-properties">
  <!-- Properties -->
  <section class="hd-basic-properties__section">
    <h4 class="hd-basic-properties__section-title hd-basic-properties__section-title--with-info">
      <span>{{ v.labels.properties }}</span>
      <!-- Weergave-toggle Tegels/Lijst (gebruikerssetting) links van het basics-info-icoon. -->
      <e-segmented-toggle
        class="hd-basic-properties__view-toggle"
        size="xs"
        testId="basic-properties-view"
        [groupLabel]="v.labels.viewToggle"
        [options]="viewOptions()"
        [value]="propertiesView()"
        (valueChange)="setPropertiesView($event)"
      ></e-segmented-toggle>
      <button type="button" class="hd-basic-properties__info-button"
              [attr.aria-label]="v.labels.basicsInfoTooltip"
              [title]="v.labels.basicsInfoTooltip"
              (click)="onBasicsInfoClick($event)">
        <i class="fas fa-circle-info" aria-hidden="true"></i>
      </button>
    </h4>

    @if (propertiesView() === 'list') {
      <div class="hd-basic-properties__row">
        <span class="hd-basic-properties__label">{{ v.labels.type }}</span>
        <span class="hd-basic-properties__value">
          <ng-container *ngTemplateOutlet="typeValue" />
        </span>
        <button type="button" class="hd-basic-properties__info-button"
                [attr.aria-label]="v.labels.typeInfoTooltip"
                [title]="v.labels.typeInfoTooltip"
                (click)="onTypeInfoClick($event)">
          <i class="fas fa-circle-info" aria-hidden="true"></i>
        </button>
      </div>

      @for (row of v.rows; track row.key) {
        @if (environmentMatchesEnabled() && row.matchKind; as kind) {
          <!-- Rij mét omgeving-matchlijst: de lijst klapt bínnen de rij uit zodat
               de zebra-afwisseling van de rijen eronder blijft kloppen. -->
          <div class="hd-basic-properties__row hd-basic-properties__row--with-matches">
            <div class="hd-basic-properties__row-main">
              <span class="hd-basic-properties__label">{{ row.name }}</span>
              <span class="hd-basic-properties__value"
                    [class.hd-basic-properties__value--hoverable]="!!row.hoverGates"
                    (mouseenter)="onRowGatesEnter(row)" (mouseleave)="onRowGatesLeave(row)">{{ row.value }}</span>
              @if (row.infoTooltip) {
                <button type="button" class="hd-basic-properties__info-button"
                        [attr.aria-label]="row.infoTooltip"
                        [title]="row.infoTooltip"
                        (click)="onRowInfoClick(row, $event)">
                  <i class="fas fa-circle-info" aria-hidden="true"></i>
                </button>
              }
              @if (viewMode() !== 'guest') {
                <button type="button" hdChartMatchToggle class="hd-basic-properties__match-toggle"
                        [open]="isEnvironmentExpanded(kind)"
                        [tooltip]="row.matchTooltip ?? ''"
                        (click)="toggleEnvironmentMatches(kind)"></button>
              }
            </div>
            @if (isEnvironmentExpanded(kind)) {
              <div class="hd-basic-properties__match-list">
                <ng-container *ngTemplateOutlet="environmentMatchList; context: { $implicit: kind }" />
              </div>
            }
          </div>
        } @else {
          <div class="hd-basic-properties__row">
            <span class="hd-basic-properties__label">{{ row.name }}</span>
            <span class="hd-basic-properties__value"
                  [class.hd-basic-properties__value--hoverable]="!!row.hoverGates"
                  (mouseenter)="onRowGatesEnter(row)" (mouseleave)="onRowGatesLeave(row)">{{ row.value }}</span>
            @if (row.infoTooltip) {
              <button type="button" class="hd-basic-properties__info-button"
                      [attr.aria-label]="row.infoTooltip"
                      [title]="row.infoTooltip"
                      (click)="onRowInfoClick(row, $event)">
                <i class="fas fa-circle-info" aria-hidden="true"></i>
              </button>
            }
          </div>
        }
      }

      <div class="hd-basic-properties__row">
        <span class="hd-basic-properties__label">{{ v.labels.circuitry }}</span>
        <span class="hd-basic-properties__value">
          <ng-container *ngTemplateOutlet="circuitryValue" />
        </span>
      </div>

      @if (v.primaryConditioning.kind !== 'none') {
        <div class="hd-basic-properties__row">
          <span class="hd-basic-properties__label">{{ v.primaryConditioning.label }}</span>
          <span class="hd-basic-properties__value">
            <hd-primary-conditioning-value [vm]="v.primaryConditioning"
              (centerHover)="$event ? onCenterHoverEnter($event) : onCenterHoverLeave()"
              (bridgeGateHover)="$event != null ? onBridgeGateEnter($event) : onBridgeGateLeave()"
              (bridgeGateClicked)="onBridgeGateClick($event.gate, $event.event)" />
          </span>
          <button
            type="button"
            class="hd-basic-properties__info-button"
            [attr.aria-label]="v.primaryConditioning.infoTooltip"
            [title]="v.primaryConditioning.infoTooltip"
            (click)="onConditioningInfoClick($event)"
          >
            <i class="fas fa-circle-info" aria-hidden="true"></i>
          </button>
        </div>
      }
    } @else {
      <!-- Tegels: eerst de halve tegels per twee (type t/m definitie), dan profiel en
           kruisen over de volle breedte (hun matchlijsten klappen daar ruim uit), en
           onderaan primaire conditionering naast de circuits. -->
      <div class="hd-basic-properties__tiles" data-test-id="basic-properties-tiles">
        <hd-property-tile [icon]="tileIcons.type" [label]="v.labels.type" data-test-id="basic-property-type">
          <button tileAction type="button" class="hd-basic-properties__info-button"
                  [attr.aria-label]="v.labels.typeInfoTooltip"
                  [title]="v.labels.typeInfoTooltip"
                  (click)="onTypeInfoClick($event)">
            <i class="fas fa-circle-info" aria-hidden="true"></i>
          </button>
          <span class="hd-basic-properties__tile-value"><ng-container *ngTemplateOutlet="typeValue" /></span>
        </hd-property-tile>

        <!-- De rijen staan al in tegelvolgorde: strategie t/m definitie half, profiel en kruisen breed. -->
        @for (row of v.rows; track row.key) {
          <ng-container *ngTemplateOutlet="rowTile; context: { $implicit: row }" />
        }

        @if (v.primaryConditioning.kind !== 'none') {
          <hd-property-tile [icon]="tileIcons.primaryConditioning" [label]="v.primaryConditioning.label"
                            data-test-id="basic-property-primaryConditioning">
            <button tileAction type="button" class="hd-basic-properties__info-button"
                    [attr.aria-label]="v.primaryConditioning.infoTooltip"
                    [title]="v.primaryConditioning.infoTooltip"
                    (click)="onConditioningInfoClick($event)">
              <i class="fas fa-circle-info" aria-hidden="true"></i>
            </button>
            <span class="hd-basic-properties__tile-value"><hd-primary-conditioning-value [vm]="v.primaryConditioning"
  (centerHover)="$event ? onCenterHoverEnter($event) : onCenterHoverLeave()"
  (bridgeGateHover)="$event != null ? onBridgeGateEnter($event) : onBridgeGateLeave()"
  (bridgeGateClicked)="onBridgeGateClick($event.gate, $event.event)" /></span>
          </hd-property-tile>
        }
        <!-- Zonder conditionering (geen definitie) staan de circuits alleen: volle breedte. -->
        <hd-property-tile [icon]="tileIcons.circuitry" [label]="v.labels.circuitry"
                          [wide]="v.primaryConditioning.kind === 'none'"
                          data-test-id="basic-property-circuitry">
          <span class="hd-basic-properties__tile-value"><ng-container *ngTemplateOutlet="circuitryValue" /></span>
        </hd-property-tile>
      </div>
    }
  </section>

  <!-- Defined centers -->
  <section class="hd-basic-properties__section">
    <h4 class="hd-basic-properties__section-title">{{ v.labels.definedCenters }}</h4>
    <div class="hd-basic-properties__center-list">
      @for (center of v.definedCenters; track center) {
        <hd-center-mini-card [center]="center" variant="defined" [activations]="configuration().activations"
                             interactive [chartLinked]="chartLinked()" (activated)="onCenterCardActivated(center, $event)" />
      }
    </div>
  </section>

  <!-- Undefined centers -->
  <section class="hd-basic-properties__section">
    <h4 class="hd-basic-properties__section-title">{{ v.labels.undefinedCenters }}</h4>
    <div class="hd-basic-properties__center-list">
      @for (u of v.undefinedCenters; track u.center) {
        <hd-center-mini-card [center]="u.center" [isOpen]="u.isOpen" variant="undefined" [activations]="configuration().activations"
                             interactive [chartLinked]="chartLinked()" (activated)="onCenterCardActivated(u.center, $event)" />
      }
    </div>
  </section>

  <!-- Defined channels: kanaalkaartjes, zelfde lijst-opbouw als de center-kaartjes. -->
  <section class="hd-basic-properties__section">
    <h4 class="hd-basic-properties__section-title">{{ v.labels.definedChannels }}</h4>
    <div class="hd-basic-properties__channel-list">
      @for (channelKey of v.definedChannels; track channelKey) {
        <hd-channel-list-item
          class="hd-basic-properties__channel-item"
          [channelKey]="channelKey"
          [activations]="configuration().activations"
          [planetaryActivations]="planetaryActivations()"
          [chartLinked]="chartLinked()"
          (gateInfoRequested)="gateInfoRequested.emit($event)"
          (channelInfoRequested)="channelInfoRequested.emit($event)"
        />
      }
    </div>
  </section>

  <!-- Activations -->
  <section class="hd-basic-properties__section">
    <h4 class="hd-basic-properties__section-title">{{ v.labels.activations }}</h4>

    <div class="hd-basic-properties__toggle-bar">
      <e-segmented-toggle
        testId="basic-properties-side"
        [options]="sideOptions()"
        [value]="activeSide()"
        (valueChange)="activeSide.set($event)"
      ></e-segmented-toggle>
    </div>

    <!-- Beide zijden op een telefoon: één kolom met de planeten om beurten
         (persoonlijkheid, dan design); de kolomtitels wijken voor deze legende. -->
    <div class="hd-basic-properties__activations-grid"
         [class.is-single]="activeSide() !== 'both'">
      @if (activeSide() === 'both') {
        <div class="hd-basic-properties__side-legend" data-test-id="basic-activations-side-legend">
          <span class="hd-basic-properties__activation-col-title--personality">{{ v.labels.personality }}</span>
          <span class="hd-basic-properties__side-legend-sep">·</span>
          <span class="hd-basic-properties__activation-col-title--design">{{ v.labels.design }}</span>
        </div>
      }
      @if (activeSide() === 'design' || activeSide() === 'both') {
        <div class="hd-basic-properties__activation-col">
          <h5 class="hd-basic-properties__activation-col-title hd-basic-properties__activation-col-title--design">
            {{ v.labels.design }}
          </h5>
          @for (act of v.activations.design; track $index) {
            <hd-planet-mini-card [activation]="act" [accentColor]="designAccentColor"
                                 data-side="design" [style.order]="act.interleaveOrder"
                                 interactive [chartLinked]="chartLinked()" [iconsClickable]="iconsClickable()"
                                 (activated)="onActivationCardActivated(act, $event)" />
          }
          <!-- Chiron onderaan, gedempt: informatief, geen activatie. -->
          @if (v.chiron.design; as chiron) {
            <hd-planet-mini-card class="hd-basic-properties__chiron" informative
                                 [activation]="chiron" [accentColor]="designAccentColor"
                                 data-side="design" [style.order]="chiron.interleaveOrder"
                                 [title]="v.labels.chironNoteDesign" data-test-id="basic-chiron-design"
                                 interactive [iconsClickable]="iconsClickable()"
                                 (activated)="onChironCardActivated('design', $event)" />
          }
        </div>
      }
      @if (activeSide() === 'personality' || activeSide() === 'both') {
        <div class="hd-basic-properties__activation-col">
          <h5 class="hd-basic-properties__activation-col-title hd-basic-properties__activation-col-title--personality">
            {{ v.labels.personality }}
          </h5>
          @for (act of v.activations.personality; track $index) {
            <hd-planet-mini-card [activation]="act" [accentColor]="personalityAccentColor"
                                 data-side="personality" [style.order]="act.interleaveOrder"
                                 interactive [chartLinked]="chartLinked()" [iconsClickable]="iconsClickable()"
                                 (activated)="onActivationCardActivated(act, $event)" />
          }
          @if (v.chiron.personality; as chiron) {
            <hd-planet-mini-card class="hd-basic-properties__chiron" informative
                                 [activation]="chiron" [accentColor]="personalityAccentColor"
                                 data-side="personality" [style.order]="chiron.interleaveOrder"
                                 [title]="v.labels.chironNotePersonality" data-test-id="basic-chiron-personality"
                                 interactive [iconsClickable]="iconsClickable()"
                                 (activated)="onChironCardActivated('personality', $event)" />
          }
        </div>
      }
    </div>
  </section>
</div>

<!-- Gedeelde stukken van de lijst- en de tegelweergave van de eigenschappen:
     één markup per waarde, zodat beide weergaven altijd hetzelfde tonen. -->

<ng-template #typeValue>
  @if (v.type.pure) {<span class="is-muted">{{ v.type.pure }} </span> }
  @if (v.type.modifier) {<span class="hd-basic-properties__type-modifier">{{ v.type.modifier }} </span> }
  <span>{{ v.type.base }}</span>
</ng-template>

<ng-template #rowTile let-row>
  <hd-property-tile [icon]="row.icon" [label]="row.name"
                    [wide]="row.tileWide"
                    [attr.data-test-id]="'basic-property-' + row.key">
    @if (row.infoTooltip) {
      <button tileAction type="button" class="hd-basic-properties__info-button"
              [attr.aria-label]="row.infoTooltip"
              [title]="row.infoTooltip"
              (click)="onRowInfoClick(row, $event)">
        <i class="fas fa-circle-info" aria-hidden="true"></i>
      </button>
    }
    @if (environmentMatchesEnabled() && row.matchKind && viewMode() !== 'guest') {
      <button tileAction type="button" hdChartMatchToggle class="hd-basic-properties__match-toggle"
              [open]="isRowMatchListOpen(row)"
              [tooltip]="row.matchTooltip ?? ''"
              (click)="toggleEnvironmentMatches(row.matchKind)"></button>
    }
    <span class="hd-basic-properties__tile-value"
          [class.hd-basic-properties__value--hoverable]="!!row.hoverGates"
          (mouseenter)="onRowGatesEnter(row)" (mouseleave)="onRowGatesLeave(row)">{{ row.value }}</span>
    <!-- Uitgeklapte matchlijst over de volle tegelbreedte, onder de waarde. -->
    @if (isRowMatchListOpen(row)) {
      <div tileFooter class="hd-basic-properties__match-list hd-basic-properties__tile-footer">
        <ng-container *ngTemplateOutlet="environmentMatchList; context: { $implicit: row.matchKind }" />
      </div>
    }
  </hd-property-tile>
</ng-template>

<ng-template #environmentMatchList let-kind>
  <hd-chart-match-list [state]="environmentState(kind)" [labels]="v.environment" (open)="openMatch($event)">
    <!-- Omgeving-disclaimer rechts in de kopregel: patronen, geen harde HD-regel (tooltip). -->
    <span matchListHead class="hd-basic-properties__match-list-head">
      <i class="fas fa-triangle-exclamation hd-basic-properties__match-warning"
         [title]="v.environment.disclaimer" aria-hidden="true"></i>
    </span>
    <!-- Plek + matchende waarde per treffer; sterke matches
         (alle bronwaarden gedekt) kleuren amber. -->
    <ng-template let-match>
      <span class="hd-basic-properties__match-locations"
            [attr.title]="match.strong ? v.environment.strongTooltip : null">
        @for (hit of match.hits; track hit.location + hit.value) {
          <span class="hd-basic-properties__match-location"
                [class.hd-basic-properties__match-location--strong]="match.strong">
            {{ v.environment.locations[hit.location] }} · {{ hit.value }}
          </span>
        }
      </span>
    </ng-template>
  </hd-chart-match-list>
</ng-template>

<ng-template #circuitryValue>
  @for (c of v.circuitry; track $index) {
    <span class="hd-basic-properties__circuitry-item">{{ c.name }} (<i
        [class]="'fas fa-' + c.themeIcon + ' hd-basic-properties__circuitry-icon'"
        aria-hidden="true"></i> {{ c.keynote }})</span>@if (!$last) {<span>, </span>}
  }
</ng-template>
